// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { productAvailabilityStyles } from "@conklin/Overrides/Components/ProductAvailability";
import { fontConfig } from "@conklin/XDL/PreStyle/typography";
import { IconWrapper } from "@insite/mobius/Icon";
import { css } from "styled-components";

productAvailabilityStyles.availabilityByWarehouseModal = {};
productAvailabilityStyles.container = {
    css: css`
        display: flex;
        justify-content: space-between;
    `,
};
productAvailabilityStyles.messageGridItem = {};
productAvailabilityStyles.availabilityByWarehouseLinkGridItem = {};

productAvailabilityStyles.errorText = {
    weight: fontConfig.weight.bold,
    size: fontConfig.fontSize.small,
    lineHeight: fontConfig.lineHeight.small,
    color: "text",
};

productAvailabilityStyles.messageText = {
    size: fontConfig.fontSize.small,
    lineHeight: fontConfig.lineHeight.small,
    css: css`
        width: 100%;
        letter-spacing: 0;
    `,
};

productAvailabilityStyles.inventoryMessage = {
    css: css`
        display: flex;
        gap: 4px;
        align-items: center;
        background: none;

        ${IconWrapper}, svg {
            width: 11px;
            height: auto;
        }
    `,
};

productAvailabilityStyles.availabilityByWarehouseLink = {
    typographyProps: {
        size: fontConfig.fontSize.small,
        css: css`
            white-space: nowrap;
            line-height: ${fontConfig.lineHeight.small};
        `,
    },
    css: css`
        justify-content: flex-end;
        width: 100%;
    `,
};
